<template>
  <keep-alive>
    <div class="withdrawBenefit">
      <!-- <span class="applydrawable">申請提領</span> -->
      <!-- <div class="divider"></div> -->
      <div class="WithdrawableAmount">
        <span>可提領金額</span>
        <span class="amountD">NT$</span>
        <span v-if="accountInfo" class="amountD1">{{
          accountInfo.reward
        }}</span>
        <span>（本週限額：NT${{ limit }}）</span>
      </div>
      <el-form :model="applyForm" :rules="rules" ref="applyForm">
        <el-form-item label="提領金額" prop="amount" class="amount">
          <el-input v-model="applyForm.amount" autocomplete="off"></el-input>
          <div class="AmountDes">
            <p style="margin-bottom: 20px; color:#FE7F38">
              親愛的用戶您好，為配合春節連假期間［2024/2/8～2024/2/14］銀行休息，出款時程將延至2024/2/15出款。
            </p>
            <p>
              每週最多可提領新台幣19999，單筆提領最低要求為新台幣1000。
            </p>
            <p>
              每週一8:00刷新當週可提領限額。
            </p>
            <p>申請提領至撥款，時間需要3-7個工作日，請耐心等待。</p>
            <p>若國稅局要求，nicee有義務要配合國稅局協助提供相關資料。</p>
          </div>
        </el-form-item>
      </el-form>
      <section class="withdraw-account-info">
        <h3 class="info-title">
          <span>提領至帳戶</span>
          <span class="go-edit-info" @click="gotoEditBank"
            >未認證/資料填寫有誤？前往修改 >></span
          >
        </h3>
        <div class="info-body">
          <div class="info-box">
            <div
              class="info-line"
              v-for="(item, index) in withdrawBlankInfo"
              :key="index + 'a'"
            >
              <span class="info-label">{{ item.label }}</span>
              <span>{{ item.value }}</span>
            </div>
          </div>
          <p class="info-tips">
            請仔細核對，務必確認帳戶相關的訊息填寫無誤。因個人填寫失誤造成帳款問題，平台不會承擔任何責任。
          </p>
        </div>
      </section>
      <div class="reads">
        <div class="reads_s" @click="changeIsKeepStatus">
          <div class="circle-wrap" :class="isKeepStatus && 'selected'">
            <fps-icon v-if="isKeepStatus" type="check" size="12" />
          </div>
          <div>
            我已閱讀並同意
            <span style="color: #0091FF;" @click.stop="open()">提領辦法</span>
          </div>
        </div>
        <span class="isRead" :class="{ activeKeep: !isReads }"
          >請閱讀並同意申請提領</span
        >
      </div>
      <div class="footer">
        <NButton
          class="apply-button"
          :loading="isLoading"
          :disabled="disabledSubmit"
          @click="submitForm('applyForm')"
        >
          <template v-if="reviewStatus === 'Applying'">帳戶審核中</template>
          <template v-else>
            提交
          </template>
        </NButton>
      </div>
      <el-dialog
        title="提領辦法"
        :visible.sync="dialogVisible"
        width="418px"
        :append-to-body="true"
        class="dislogmethods"
      >
        <div class="divider_mthods"></div>
        <div>
          1.
          依據臺灣相關法律規定，申請提領的用戶提供相關所需文件以利nicee官方協助完成勞務報酬單填寫，首次進行提現流程時，會需要上傳您的身份證正反面，若資料上有任何問題，nicee官方將與您聯繫相關事宜。
        </div>
        <div>
          2.
          本人擔保所提交之所有資料確認為本人所有，若有任何事情，本人願意負擔法律責任。
        </div>
        <div>
          3. 申請提領後，個人資料及銀行帳戶將自動綁定，如需更改請向客服反映。
        </div>
        <div>
          4.
          平台對用戶提交之所有圖文資料進行格式校驗。因錯誤填寫帳戶等個人原因導致的帳戶錯匯或其他問題，平台概不負責。
        </div>
      </el-dialog>
    </div>
  </keep-alive>
</template>

<script>
import { withdrawApplyV2, getBankInfo } from '@/api';
import { mapGetters } from 'vuex';
import NButton from '@/components/common/button/normal.vue';
export default {
  name: 'WithdrawBenefit',
  components: {
    NButton
  },
  data() {
    return {
      isLoading: false,
      dialogVisible: false,
      isKeepStatus: false,
      dialogFormVisible: false,
      currencyKind: '',
      isReads: false,
      visible: false,
      // withdrawBlankInfo: [
      //   { value: '***', label: '用戶名稱' },
      //   { value: '***', label: '提領銀行名' },
      //   { value: '***', label: '分行代碼' },
      //   { value: '***', label: '提領帳戶' }
      // ],
      applyForm: {
        amount: ''
      },
      reviewStatus: '',
      isWechat: false,
      limit: 0
    };
  },
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['accountInfo']),
    rules() {
      const { isAccount } = this;
      let rs = {
        amount: [
          { required: true, message: '請輸入提現金額', trigger: 'blur' },
          { validator: isAccount, trigger: 'blur' }
        ]
      };
      return rs;
    },
    disabledSubmit() {
      return this.reviewStatus !== 'Passed';
    },
    withdrawBlankInfo() {
      return [
        { value: '***', label: '用戶名稱' },
        { value: '***', label: '提領銀行名' },
        { value: '***', label: this.isWechat ? '微信昵称' : '分行代碼' },
        { value: '***', label: this.isWechat ? '微信帳號' : '提領帳戶' }
      ];
    }
  },
  watch: {
    isKeepStatus(flag) {
      if (flag) {
        this.isReads = false;
      } else {
        this.isReads = true;
      }
    },
    isShow: {
      handler: function(newVal) {
        if (!newVal) return;
        this.$nextTick(() => {
          this.bankInfoPromise.then(() => {
            if (!this.bankAccountId || this.reviewStatus === 'Rejected')
              this.confirmApplyBank();
          });
        });
      },
      immediate: true
    }
  },
  methods: {
    // 获取剩余提领额度
    async getLimit() {
      const { data } = await this.$http.get(
        '/account/withdraw/apply/v2/restrict',
        {
          addAmount: 0
        }
      );
      this.limit = data && Number(data) > 0 ? data : 0;
    },
    gotoEditBank() {
      if (this.reviewStatus === 'Applying') {
        this.$message.warning('提領帳戶審核中，暫時不可修改');
        return;
      }
      this.$router.push({ path: '/withdraw-account' });
    },
    getBankAccount() {
      let loads = this.$loading();
      this.bankInfoPromise = getBankInfo()
        .then(res => {
          let blankInfo = this.$util.getVal(res, 'data.0');
          loads.close();
          if (!blankInfo) return;
          if (blankInfo.bankName === 'wechat 微信提領') {
            this.isWechat = true;
            this.withdrawBlankInfo[0].value = blankInfo.accountUserName;
            this.withdrawBlankInfo[1].value = blankInfo.bankName;
            this.withdrawBlankInfo[2].value = blankInfo.branchName;
            this.withdrawBlankInfo[3].value = blankInfo.accountNo;
          } else {
            this.withdrawBlankInfo[0].value =
              '**' + blankInfo.accountUserName.slice(-1);
            this.withdrawBlankInfo[1].value = blankInfo.bankName;
            this.withdrawBlankInfo[2].value = blankInfo.branchName;
            this.withdrawBlankInfo[3].value =
              '**** ' + blankInfo.accountNo.slice(-4);
          }
          this.bankAccountId = blankInfo.id;
          this.reviewStatus = blankInfo.reviewStatus;
        })
        .catch(e => {
          console.error(e);
          loads.close();
        });
    },
    confirmApplyBank() {
      let isReject = this.reviewStatus === 'Rejected';
      let rejectText = '您的帳戶認證未通過，請重新認證';
      let text = isReject
        ? rejectText
        : '為保證您的帳戶安全，在進行普通提領時需經過帳戶綁定及認證。在認證期間不能資訊编辑或金額提領';
      return this.$confirm({
        content: text,
        confirmButtonText: '去認證',
        cancelButtonText: '再想想'
      })
        .then(() => {
          this.gotoEditBank();
        })
        .catch(() => {
          return false;
        });
    },
    isAccount(rule, value, callback) {
      const { accountInfo } = this;
      if (!accountInfo) return;
      let isNormal = this.$route.query.isNormal;
      //輸入的數字可以是整數，可以是小數，但是不能超過2位小數
      let regEn = /^\d{1,4}$/;
      if (isNormal === 'Invitation') {
        if (value >= 10000) {
          callback('單次提領不能超過9999');
        } else if (!regEn.test(value)) {
          callback(new Error('請輸入整數'));
        } else if (value > accountInfo.reward) {
          callback(new Error('餘額不足'));
        } else if (value == 0) {
          callback(new Error('提取金額不能為0'));
        }
      } else {
        if (value > this.limit) {
          callback(new Error('已超過可提領額度'));
        }
        if (value >= 10000) {
          callback('單次提領不能超過9999');
        } else if (!regEn.test(value)) {
          callback(new Error('請輸入整數'));
        } else if (value < 1000) {
          callback(new Error('每次提領金額不能小於NT$1000'));
        } else if (value > accountInfo.reward) {
          callback(new Error('餘額不足'));
        } else if (value == 0) {
          callback(new Error('提取金額不能為0'));
        }
      }

      callback();
    },
    /**
     * @description 是否记住選擇状态
     */
    changeIsKeepStatus() {
      this.isKeepStatus = !this.isKeepStatus;
    },
    submitForm(formName) {
      if (this.isLoading) return;
      if (this.reviewStatus === 'Applying') {
        this.$message('提領帳戶審核中，暫時不可提交');
        return;
      }
      if (this.disabledSubmit) {
        this.confirmApplyBank();
        return;
      }
      this.$refs[formName].validate(async valid => {
        if (!valid) return;
        let params = {
          accountKind: 'Reward', //個人帳戶reward   激勵帳戶Cash 要根據不同情況實時改變字段
          bankAccountId: this.bankAccountId, //綁定的銀行帳戶
          currencyKind: 'TWD', //貨幣類型
          withdrawKind: 'Normal',
          amount: this.applyForm.amount
        };

        if (this.isKeepStatus) {
          //ajax
          this.isLoading = true;
          withdrawApplyV2(params)
            .then(res => {
              if (res.code == 200) {
                this.$message.success('提交成功');
                this.$router.go(-1);
              } else {
                this.$message.error(res.msg);
              }
              this.isLoading = false;
            })
            .catch(e => {
              this.isLoading = false;
              if (e.msg) {
                this.$message.error(e.msg);
              }
            });
        } else {
          this.isReads = true;
        }
      });
    },
    open() {
      this.dialogVisible = true;
    }
  },
  created() {
    this.getBankAccount();
    this.getLimit();
  }
};
</script>
<style lang="scss" scoped>
.withdrawBenefit {
  margin: 0 auto;
  padding-bottom: 60px;
  margin-bottom: 100px;
  background: #ffffff;
  .el-dialog__wrapper {
    & /deep/ .el-dialog {
      border-radius: 8px;
    }
    & /deep/ .el-dialog__body {
      padding: 0;
      padding-bottom: 60px;
      // padding: 0 30px 60px 30px;
      .divider_mthods {
        width: 100%;
        height: 1px;
        background: #ececec;
      }
      div {
        font-size: 14px;
        color: #333333;
        padding: 0 30px 0 30px;
        line-height: 20px;
        margin-bottom: 20px;
      }
    }
  }
  .footer {
    width: 142px;
    height: 46px;
    border-radius: 4px;
    text-align: center;
    margin-left: 40px;
    button {
      width: 168px;
      height: 48px;
      border-radius: 50px;
      background: $color-yellow;
      font-weight: 500;
      font-size: 16px;
      line-height: 48px;
      text-align: center;
      letter-spacing: -0.000319808px;
      color: $color-gray-1;
    }
  }
  .reads {
    width: 191px;
    margin-left: 40px;
    text-align: center;
    overflow: hidden;
    .reads_s {
      cursor: pointer;
      display: flex;
      div {
        vertical-align: center;
        font-weight: 500;
        font-size: 14px;
        color: #666666;
        span {
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
    .circle-wrap {
      width: 16px;
      height: 16px;
      border: 1px solid #8c94aa;
      box-sizing: border-box;
      box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.1);
      border-radius: 50%;
      margin-right: 8px;
      cursor: pointer;
      &.selected {
        border: none;
        background: $color-yellow;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .isRead {
      font-weight: 500;
      font-size: 12px;
      line-height: 17px;
      color: #fd2243;
    }
    .activeKeep {
      opacity: 0;
    }
  }
  & /deep/ .el-form {
    padding: 0 40px;
    overflow: hidden;
    .amount {
      position: relative;
      height: 90px;
      & /deep/ .el-form-item__content {
        line-height: 20px;
      }
      .AmountDes {
        position: absolute;
        left: 454px;
        top: 25px;
        font-weight: normal;
        font-size: 13px;
        color: #636d86;
        line-height: 17px;
      }
    }
    .el-form-item__label {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: #666666;
      padding-bottom: 5px;
      &::before {
        content: '';
      }
    }
    .el-form-item__content {
      .el-form-item__error {
        font-weight: 500;
        font-size: 12px;
        color: #fd2243;
      }
      .el-input {
        .el-input__inner {
          width: 434px;
          background: #f6f6f6;
          border-radius: 4px;
          &::placeholder {
            font-size: 14px;
          }
          &:focus {
            background: #ffffff;
            box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.15);
            border-radius: 4px;
          }
        }
      }
      el-select {
        width: 434px;
        height: 40px;
        background: #f6f6f6;
        border-radius: 4px;
      }
    }
  }
  el-select {
    width: 434px;
    height: 40px;
    background: #f6f6f6;
    border-radius: 4px;
  }

  .applydrawable {
    margin-left: 40px;
    font-size: 22px;
    line-height: 31px;
    color: #333333;
  }
  .divider {
    width: 1200px;
    height: 2px;
    background: #f4f4f4;
    margin-top: 20px;
  }
  .WithdrawableAmount {
    margin-left: 40px;
    margin-top: 32px;
    margin-bottom: 42px;
    display: flex;
    align-items: center;
    span {
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      color: $color-gray-1;
      margin-right: 12px;
    }
    .amountD,
    .amountD1 {
      font-weight: 600;
      font-size: 22px;
      line-height: 26px;
      color: $color-orange;
    }
  }
}
.withdraw-account-info {
  padding: 0 40px;
}
.info-title {
  display: flex;
  justify-content: space-between;
  width: 434px;
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 14px;
  color: #222c43;
}
.go-edit-info {
  font-weight: 400;
  font-size: 12px;
  color: #007aff;
  cursor: pointer;
}
.info-body {
  display: flex;
  justify-content: space-between;
  margin-bottom: 56px;
}
.info-box {
  flex-grow: 0;
  flex-shrink: 0;
  width: 434px;
  padding: 10px 12px;
  border: 1px solid #e8eaee;
  margin-right: 20px;
  font-size: 13px;
  line-height: 18px;
  color: #636d86;
  border-radius: 4px;
  background: #f9f9f9;
}
.info-line {
  margin-bottom: 8px;
  &:last-child {
    margin-bottom: 0;
  }
}
.info-label {
  display: inline-block;
  width: 100px;
}
.info-tips {
  font-size: 13px;
  line-height: 18px;
  color: #636d86;
}
.apply-button {
  min-width: 156px;
}
</style>
